import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parseQueryString, QueryParameters } from '@moda/portal-stanchions';
import { useCookies, getCookies } from './useCookies';

const STORE_KEY = 'sessionQueryParams';

export const useSessionQueryParams = () => {
  const { cookies, setCookie, deleteCookie } = useCookies();
  const location = useLocation();
  const params: QueryParameters = JSON.parse(cookies.sessionQueryParams ?? '{}');

  useEffect(() => {
    const queryParams = parseQueryString(location.search);
    const storedParams = JSON.parse(getCookies().sessionQueryParams ?? '{}');
    if (Object.keys(queryParams).length) {
      setCookie(STORE_KEY, JSON.stringify({ ...storedParams, ...queryParams }));
    }
  }, [location.search, setCookie, deleteCookie]);

  return params;
};
